export const TestHooks = {
	Container: 'container',
} as const;
